var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB2BStats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.47,
    height: 18.47,
    viewBox: "0 0 18.47 18.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6861",
    "data-name": "Path 6861",
    d: "M19.263,13.512v4.007A2.054,2.054,0,0,1,17.5,19.574a45.686,45.686,0,0,1-6.013.4,45.686,45.686,0,0,1-6.013-.4,2.054,2.054,0,0,1-1.765-2.055V13.512m15.556,0a2.055,2.055,0,0,0,.707-1.566V8.38a2.055,2.055,0,0,0-1.732-2.051q-1.6-.24-3.218-.365m4.243,7.548a1.92,1.92,0,0,1-.635.358,22.606,22.606,0,0,1-7.144,1.15,22.626,22.626,0,0,1-7.144-1.15,1.9,1.9,0,0,1-.635-.358m0,0A2.055,2.055,0,0,1,3,11.946V8.38A2.055,2.055,0,0,1,4.732,6.329q1.6-.24,3.218-.365m7.071,0V5.121A2.121,2.121,0,0,0,12.9,3H10.071A2.121,2.121,0,0,0,7.95,5.121v.843m7.071,0a45.883,45.883,0,0,0-7.071,0m3.535,6.228h.008V12.2h-.008Z",
    transform: "translate(-2.25 -2.25)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BStats);
export default __webpack_public_path__ + "static/media/b2b-stats.8b3841d4.svg";
export { ForwardRef as ReactComponent };